Vue.component('grid-swatches', {
  template: `
    <div v-if="colorOption.length" class="category-product__swatches">

        <div
          class="swatch"
          v-for="swatch in colorOption"
          :style="{
            backgroundColor: swatch.color
          }"
        ></div>
    </div>
  `,
  props: {
    product: {
      type: Object,
      required: false,
    },
  },
  computed: {
    colorOption() {
      const product = this.product;

      if(!product) return [];

      const option = product.options['Color']
      
      if(!option) return [];

      return option.map((optionValue) => {
        const match = window.WIP?.swatches.find((item) => item.value === optionValue);

        return match;
      }).filter(Boolean);
    }
  },
  data() {},
  methods: {},
  mounted() {
    console.log('Swatches mounted:', this.product, this.colorOption);
  }
});

Vue.component("grid-item", {
  template: document.querySelector("script[data-grid-item-template]").innerHTML,
  props: {
    product: {
      type: Object,
      required: false,
    },
    handle: {
      type: String,
      required: false,
    },
    activeWishlistIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    isActiveWishlistItem() {
      return Boolean(this.activeWishlistIds.find((id) => id == this.item.id));
    },
    inquireForPrice() {
      if (!this.product) return false;

      const inquire = this.product.metafields.inquireForPricing;
      return inquire;
    },
  },
  data() {
    return {
      item: this.product,
      selected: "",
    };
  },
  methods: {
    handleWishlistClick(event) {
      event.preventDefault();
      console.log("wishlist click", this.item);

      const inventoryQty = [...this.item.variants].reduce((total, variant) => {
        return total + variant.inventory_quantity;
      }, 0);

      const variants = [...this.item.variants].map((variant) => {
        return {
          [variant.title]: variant.id,
        };
      });

      const wishlistProduct = {
        epi: this.item.variants[0].id,
        du: `https://jenmeyer.myshopify.com${this.item.url}`,
        empi: this.item.id,
        iu: this.item.images[0],
        dt: this.item.title,
        pr: this.item.price,
        et: 1,
        stk: inventoryQty,
        variants,
      };

      const replacementProduct = {
        epi: this.item.variants[0].id,
        du: `https://jennifermeyer.com/products/${this.item.handle}`,
        empi: this.item.id,
        et: 4,
      };

      //   console.log("Wishlist Product:", wishlistProduct, {
      //     replacementProduct: JSON.parse(JSON.stringify(replacementProduct)),
      //   });

      if (this.isActiveWishlistItem) {
        window._swat.removeFromWishList(
          JSON.parse(JSON.stringify(replacementProduct)),
          (r) => {
            console.log("Removed from wishlist");
            this.$emit("wishlist-update", {
              add: false,
              item: r,
            });
          }
        );
      } else {
        window._swat.addToWishList(
          JSON.parse(JSON.stringify(replacementProduct)),
          (r) => {
            // console.log("Added to wishlist", r);
            this.$emit("wishlist-update", {
              add: true,
              item: r,
            });
          }
        );
      }
    },
    formatMoney(amount) {
      return window.Shopify.formatMoney(amount, "${{ amount_no_decimals }}");
    },
    async fetchProductByHandle(handle) {
      const product = await fetch(`/products/${handle}?view=data`).then((res) =>
        res.json()
      );

      this.item = product;
      
        console.log("[GridItem] Product:", product, product.title);
      return product;
    },
  },
  mounted() {
    if (!this.product && this.handle) {
      this.fetchProductByHandle(this.handle);
    } else if (this.product) {
        console.log("[GridItem] Product:", this.product, this.product.title);
      this.item = this.product;
    }

    // setTimeout(() => {
    // zonos.config(z_store);
    // }, 500);
  },
});
